import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useBooleanFlagValue } from '@openfeature/react-sdk';
import { ROUTES } from '@/shared/config/routes';

/** The Widgets library exists only where the agent builder is on, since widgets are made there. */
export function RequireWidgets({ children }: { children: ReactNode }) {
  // Suspends until flags have loaded, so the page never flashes the Tools list first.
  const widgetsOn = useBooleanFlagValue('relay_agent_builder', false, { suspendUntilReady: true });
  return widgetsOn ? <>{children}</> : <Navigate to={ROUTES.ADMIN_TOOLS} replace />;
}
